
<template>
  <!--批量分配钥匙-->
  <x-addEdit
    :formList="formList"
    :addParam="addParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'batchAllocation',
  data () {
    let decoratorOptions = {
      community_id: {
        rules: [{ required: true, message: '请选择小区' }]
      },
      position_id: {
        rules: [{ required: true, message: '请选择位置' }]
      },
      door_eq_id: {
        rules: [{ required: true, message: '请选择设备' }]
      }
    };
    return {
      formList: [
        {
          label: '小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择小区',
          handle: ($event) => this.communityChange_getPosi(1, $event, 'formList'),
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择位置',
          handle: ($event) => this.positionChange(2, $event, 'formList'),
          props: ['position_id', decoratorOptions.position_id]
        },
        {
          label: '可选设备',
          inputType: 'select',
          options: [],
          placeholder: '请选择设备',
          props: ['door_eq_id', decoratorOptions.door_eq_id]
        }
      ],
      addParam: {
        url: '/key_list/lot',
        reqHandle: '', // this.reqHandle
        resHandle: this.addResHandle // this.addResHandle
      }
    };
  },
  mounted () {
    this.communitySelect(0, 'formList', '1');
  },
  methods: {
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      this.$message.success(`${res.msg}`).then(() => {
        this.$router.go(-1);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/keyList/batchAllocation.vue